module.exports = __webpack_public_path__ + "static/img/011酒庄官网2.e6d9681.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/011酒庄官网2.jpg
// module id = rAHw
// module chunks = 0